import i18next from 'i18next';
import * as React from 'react';

const handleUnload = (e: BeforeUnloadEvent) => {
  const confirmationMessage = i18next.t('register.modal.leaving_alert');
  e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
  return confirmationMessage; // Gecko, WebKit, Chrome <34
};

export const attachUnloadHandler = () => {
  window.addEventListener('beforeunload', handleUnload, false);
};

export const detachUnloadHandler = () => {
  window.removeEventListener('beforeunload', handleUnload, false);
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const withUnloadConfirm = <TOriginalProps extends {}>(
  Component: React.ComponentType<TOriginalProps>,
) =>
  class WrappedInnerForm extends React.Component<TOriginalProps> {
    public static displayName = `withUnloadConfirm(${Component.displayName})`;

    public componentDidMount() {
      attachUnloadHandler();
    }

    public componentWillUnmount() {
      detachUnloadHandler();
    }

    public render() {
      return <Component {...this.props} />;
    }
  };
